<template>
<div class="chapter">
<div class="inner_page">
<div class="contentsPage" id="d7e15">
<h3 class="toc" id="d7e16">Contents</h3>
<p class="contentsDiv">
<a href="#/HARP_9780715337851_epub_c1#c1">Premonitions of the <i>Titanic's</i> Doom</a>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c2#c2" title="Link target outside of Sample">Talk of the Devil</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c3#c3" title="Link target outside of Sample">The Headless Lover</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c4#c4" title="Link target outside of Sample">The Phantoms, the Derelicts and the Haunted</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c5#c5" title="Link target outside of Sample">The Carters and the Poltergeist</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c6#c6" title="Link target outside of Sample">Screaming Skulls and Other Oddities</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c7#c7" title="Link target outside of Sample">A Stranger in the Fog</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c8#c8" title="Link target outside of Sample">The Ship and the Phantom Faces</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c9#c9" title="Link target outside of Sample">Ghosts on the Road</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c10#c10" title="Link target outside of Sample">The Phantom Train</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c11#c11" title="Link target outside of Sample">The Return from Silence</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c12#c12" title="Link target outside of Sample">Hell Hounds and Other Creatures</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c13#c13" title="Link target outside of Sample">The Pilot of the <i>Pinta</i>
</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c14#c14" title="Link target outside of Sample">The Footplate Ghost</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c15#c15" title="Link target outside of Sample">The Terrifying Experience of Mr and Mrs Carrington</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c16#c16" title="Link target outside of Sample">The Holy Fathers</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c17#c17" title="Link target outside of Sample">What the Rector Saw</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c18#c18" title="Link target outside of Sample">The Skull in the Box</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c19#c19" title="Link target outside of Sample">The Curse of Doris Cook</span>
<br/>
</p>
<p class="contentsDiv">
<span href="#/HARP_9780715337851_epub_c20#c20" title="Link target outside of Sample">The Chairman</span>
<br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// HARP_9780715337851_epub_toc.vue?4f47d697